// eslint-disable-next-line @alto/no-pocky-import
import {
  Button,
  DeprecatedModal,
  DeprecatedModalBody,
  DeprecatedModalFooter,
  FlexRow,
  H3,
  Text,
  spacing,
} from '@alto/pocky';
import React, { PureComponent } from 'react';
import { type ModalType } from '~shared/actions/modal';
import doctorName from '~shared/helpers/doctorName';
import { type LightDoctor } from '~shared/types';

type Props = {
  readonly doctor: LightDoctor | undefined;
  readonly onClose: () => void;
  readonly show: boolean | undefined;
  readonly modalType: ModalType | null;
};

export default class CardFinderInfoModal extends PureComponent<Props> {
  render() {
    const { doctor, onClose, show, modalType } = this.props;
    const shown = show && modalType === 'CARDFINDER_INFO_MODAL';
    return shown ? (
      <DeprecatedModal
        showing={shown}
        onClose={onClose}
        title="How it works"
      >
        <DeprecatedModalBody>
          <FlexRow spacing={spacing.mdSpacing}>
            <Text>The information provided by {doctorName(doctor)} helped us locate your insurance information.</Text>
            <Text>
              This information is stored securely and never shared with anyone else. Your privacy is our top priority.
            </Text>
            <FlexRow spacing={spacing.xsSpacing}>
              <H3>Can I change my insurance later?</H3>
              <Text>
                Absolutely! You can update your insurance information at any time in the &quot;Profile&quot; tab.
              </Text>
            </FlexRow>
          </FlexRow>
        </DeprecatedModalBody>
        <DeprecatedModalFooter>
          <Button onClick={onClose}>Back To Insurance</Button>
        </DeprecatedModalFooter>
      </DeprecatedModal>
    ) : null;
  }
}
